import React, { useEffect, useState } from 'react';
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { getUsers, getPagePermissions, getPartPermissions, deleteUser } from '../../api/axios';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import EditUserModal from '../EditUser/EditUserModal';
import { useTranslation } from 'react-i18next';
import './users.css';
import { decryptToken } from '../../utils/Crypto';


const Users = () => {  
  const [users, setUsers] = useState([]);
  const [columns, setColumns] = useState([]);

  const [open, setOpen] = useState(false); // State za modal
  const [editingUser, setEditingUser] = useState(null); //Korisnik koji se edituje
  const [isDeleting, setIsDeleting] = useState(false);

  const [pagePermissions, setPagePermissions] = useState({});
  const [partPermissions, setPartPermissions] = useState({});

  const { t } = useTranslation('global');

  const columnDisplayNames = {
    username: t('users.username'),
    password: t('users.password'),
    email: t('users.email'),
    access_level: t('users.accessLevel'),
    registartion_date: t('users.registrationDate')  ///Ima typo u bazi
  };

  useEffect(() => {
    const fetchUsers = async () => {
        try {
          const accessToken = localStorage.getItem("accessToken");
          const usersData = await getUsers(accessToken);

          const pagePerms = await getPagePermissions(accessToken);
          setPagePermissions(pagePerms);

          const partPerms = await getPartPermissions(accessToken, '/korisnik');
          setPartPermissions(partPerms);

          if (Array.isArray(usersData.users)) {
            setUsers(usersData.users);
            if (usersData.users.length > 0) {
              setColumns(Object.keys(usersData.users[0]));
            }
          } else {
            console.error("Expected usersData.users to be an array, got:", usersData.users);
            setUsers([]);
          }
        } catch (error) {
          console.error('Error fetching users:', error);
          setUsers([]);
        }
      };

    fetchUsers();
  }, []);

  const handleEdit = (userId) => {
    const userToEdit = users.find(user => user.id === userId);
    setEditingUser(userToEdit);
    console.log(editingUser);
    setOpen(true);
  };
  
  const handleDeleteError = (error) => {
    if (error.response) {
      const { status } = error.response;
      if (status === 401) {
        alert('Greška sa tokenom ili nije poslat.');
      } else if (status === 400) {
        alert('Greška prilikom brisanja ili nije poslat parametar id.');
      } else if (status === 405) {
        alert('Metoda nije dozvoljena.');
      } else {
        alert('Došlo je do greške.');
      }
    } else {
      alert('Došlo je do greške u komunikaciji sa serverom.');
    }
  };
  
  const handleDelete = async (id) => {
    const confirmed = window.confirm('Da li ste sigurni da želite da obrišete ovog korisnika?');
    if (confirmed) {
      setIsDeleting(true); // Set deleting state to true while processing
      try {
        const accessToken = localStorage.getItem('accessToken');
        const params = new URLSearchParams(); 
        params.append('id', id);
        params.append('accessToken', accessToken);
        const response = await deleteUser(params);
  
        if (response.status === 200 && response.data.success) {
          setUsers((prevUsers) => prevUsers.filter((user) => user.id !== id));
          alert('Korisnik uspešno obrisan.');
        } else {
          alert(`Greška: ${response.data.message}`);
        }
      } catch (error) {
        handleDeleteError(error);
      } finally {
        setIsDeleting(false); // Reset deleting state once completed
      }
    }
  };

  return (
    <Box sx={{ maxWidth: 1200, margin: 'auto' }}>
<TableContainer component={Paper}>
  <Table className ="usersTable">
    <TableHead>
      <TableRow className="tableHeader">
        <TableCell style={{ fontWeight: 'bold' }}>#</TableCell>
        {columns.filter(column => (column !== 'id' && column !== 'password')).map((column) => (
          <TableCell key={column} style={{ fontWeight: 'bold' }}>
            {columnDisplayNames[column] || column}
          </TableCell>
        ))}
        <TableCell style={{ fontWeight: 'bold' }}>{t('users.actions')}</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {Array.isArray(users) && users.length > 0 ? (
        users.map((user, index) => (
          <TableRow key={user.id} className="stripedRow">
            <TableCell>{index + 1}</TableCell>
            {columns.filter(column => (column !== 'id' && column !== 'password')).map((column) => (
              <TableCell key={column}>
                {user[column]}
              </TableCell>
            ))}
            <TableCell>
              {pagePermissions['/korisnik']?.can_view === "1" && (
                <>
                {partPermissions['novi korisnik']?.can_edit === "1" && (
                  <Button
                    onClick={() => handleEdit(user.id)}
                    className="actionButtonIcon"
                  >
                    <EditIcon />
                  </Button>
                )}
                {partPermissions['novi korisnik']?.can_delete === "1" && (
                  <Button
                    onClick={() => handleDelete(user.id)}
                    className="actionButtonIcon delete"
                  >
                    <DeleteIcon />
                  </Button>
                )}
              </>
              
              )}
            </TableCell>
          </TableRow>
        ))
      ) : (
        <TableRow>
          <TableCell colSpan={columns.length + 2}>{t('users.noUsersFound')}</TableCell>
        </TableRow>
      )}
    </TableBody>
  </Table>
</TableContainer>

      {
        open && editingUser && (
          <EditUserModal open={open} setOpen={setOpen} editingUser={editingUser} setEditingUser={setEditingUser} setUsers={setUsers} users={users} />
        )
      }
    </Box>
  );
};

export default Users;